export default __webpack_public_path__ + "static/media/lisieux06.ee2ad6f0.jpg";